export const START_LOADING = 'START_LOADING';

export const GET_ELECTRICITY_PURCHASED_PER_GROUP_SUCCESS = 'GET_ELECTRICITY_PURCHASED_PER_GROUP_SUCCESS';
export const GET_ELECTRICITY_PURCHASED_PER_GROUP_FAIL = 'GET_ELECTRICITY_PURCHASED_PER_GROUP_FAIL';

export const GET_ELECTRICITY_PURCHASED_PER_FACILITY_SUCCESS = 'GET_ELECTRICITY_PURCHASED_PER_FACILITY_SUCCESS';
export const GET_ELECTRICITY_PURCHASED_PER_FACILITY_FAIL = 'GET_ELECTRICITY_PURCHASED_PER_FACILITY_FAIL';

export const GET_RENEWABLE_ENERGY_PER_GROUP_SUCCESS = 'GET_RENEWABLE_ENERGY_PER_GROUP_SUCCESS';
export const GET_RENEWABLE_ENERGY_PER_GROUP_FAIL = 'GET_RENEWABLE_ENERGY_PER_GROUP_FAIL';

export const GET_RENEWABLE_ENERGY_PER_FACILITY_SUCCESS = 'GET_RENEWABLE_ENERGY_PER_FACILITY_SUCCESS';
export const GET_RENEWABLE_ENERGY_PER_FACILITY_FAIL = 'GET_RENEWABLE_ENERGY_PER_FACILITY_FAIL';

// FUEL COMBUSTED PER GROUP

export const GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_STATIONARY_SUCCESS = 'GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_STATIONARY_SUCCESS';
export const GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_STATIONARY_FAIL = 'GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_STATIONARY_FAIL';

export const GET_FUEL_COMBUSTED_PER_GROUP_PETROL_STATIONARY_SUCCESS = 'GET_FUEL_COMBUSTED_PER_GROUP_PETROL_STATIONARY_SUCCESS';
export const GET_FUEL_COMBUSTED_PER_GROUP_PETROL_STATIONARY_FAIL = 'GET_FUEL_COMBUSTED_PER_GROUP_PETROL_STATIONARY_FAIL';

export const GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_MOBILE_SUCCESS = 'GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_MOBILE_SUCCESS';
export const GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_MOBILE_FAIL = 'GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_MOBILE_FAIL';

export const GET_FUEL_COMBUSTED_PER_GROUP_PETROL_MOBILE_SUCCESS = 'GET_FUEL_COMBUSTED_PER_GROUP_PETROL_MOBILE_SUCCESS';
export const GET_FUEL_COMBUSTED_PER_GROUP_PETROL_MOBILE_FAIL = 'GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_STATIONARY_FAIL';

// FUEL COMBUSTED PER FACILITY

export const GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_STATIONARY_SUCCESS = 'GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_STATIONARY_SUCCESS';
export const GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_STATIONARY_FAIL = 'GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_STATIONARY_FAIL';

export const GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_MOBILE_SUCCESS = 'GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_MOBILE_SUCCESS';
export const GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_MOBILE_FAIL = 'GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_MOBILE_FAIL';

export const GET_FUEL_COMBUSTED_PER_FACILITY_PETROL_MOBILE_SUCCESS = 'GET_FUEL_COMBUSTED_PER_FACILITY_PETROL_MOBILE_SUCCESS';
export const GET_FUEL_COMBUSTED_PER_FACILITY_PETROL_MOBILE_FAIL = 'GET_FUEL_COMBUSTED_PER_FACILITY_PETROL_MOBILE_FAIL';

// LPG COMBUSTED PER GROUP
export const GET_LPG_COMBUSTED_PER_GROUP_SUCCESS = 'GET_LPG_COMBUSTED_PER_GROUP_SUCCESS';
export const GET_LPG_COMBUSTED_PER_GROUP_FAIL = 'GET_LPG_COMBUSTED_PER_GROUP_FAIL';
export const GET_LPG_COMBUSTED_PER_FACILITY_SUCCESS = 'GET_LPG_COMBUSTED_PER_FACILITY_SUCCESS';
export const GET_LPG_COMBUSTED_PER_FACILITY_FAIL = 'GET_LPG_COMBUSTED_PER_FACILITY_FAIL';

// REFRIGERANT GAS TOP UPS PER GROUP/FACILITY
export const GET_REFRIGERANT_GAS_TOP_UPS_PER_GROUP_SUCCESS = 'GET_REFRIGERANT_GAS_TOP_UPS_PER_GROUP_SUCCESS';
export const GET_REFRIGERANT_GAS_TOP_UPS_PER_GROUP_FAIL = 'GET_REFRIGERANT_GAS_TOP_UPS_PER_GROUP_FAIL';

export const GET_REFRIGERANT_GAS_TOP_UPS_PER_FACILITY_SUCCESS = 'GET_REFRIGERANT_GAS_TOP_UPS_PER_FACILITY_SUCCESS';
export const GET_REFRIGERANT_GAS_TOP_UPS_PER_FACILITY_FAIL = 'GET_REFRIGERANT_GAS_TOP_UPS_PER_FACILITY_FAIL';

// DRY ICE PURCHASED PER GROUP/FACILITY
export const GET_DRY_ICE_PURCHASED_PER_GROUP_SUCCESS = 'GET_DRY_ICE_PURCHASED_PER_GROUP_SUCCESS';
export const GET_DRY_ICE_PURCHASED_PER_GROUP_FAIL = 'GET_DRY_ICE_PURCHASED_PER_GROUP_FAIL';

export const GET_DRY_ICE_PURCHASED_PER_FACILITY_SUCCESS = 'GET_DRY_ICE_PURCHASED_PER_FACILITY_SUCCESS';
export const GET_DRY_ICE_PURCHASED_PER_FACILITY_FAIL = 'GET_DRY_ICE_PURCHASED_PER_FACILITY_FAIL';

// WASTE GENERATED PER GROUP

// ---Waste-to-Landfill---
export const GET_WASTE_TO_LANDFILL_PER_GROUP_SUCCESS = 'GET_WASTE_TO_LANDFILL_PER_GROUP_SUCCESS';
export const GET_WASTE_TO_LANDFILL_PER_GROUP_FAIL = 'GET_WASTE_TO_LANDFILL_PER_GROUP_FAIL';
// ---Waste-to-Recycling---
export const GET_WASTE_TO_RECYCLING_PER_GROUP_SUCCESS = 'GET_WASTE_TO_RECYCLING_PER_GROUP_SUCCESS';
export const GET_WASTE_TO_RECYCLING_PER_GROUP_FAIL = 'GET_WASTE_TO_RECYCLING_PER_GROUP_FAIL';
// ---Waste-to-Composting---
export const GET_WASTE_TO_COMPOSTING_PER_GROUP_SUCCESS = 'GET_WASTE_TO_COMPOSTING_PER_GROUP_SUCCESS';
export const GET_WASTE_TO_COMPOSTING_PER_GROUP_FAIL = 'GET_WASTE_TO_COMPOSTING_PER_GROUP_FAIL';
// ---Wastewater-Treatment---
export const GET_WASTEWATER_TREATMENT_PER_GROUP_SUCCESS = 'GET_WASTEWATER_TREATMENT_PER_GROUP_SUCCESS';
export const GET_WASTEWATER_TREATMENT_PER_GROUP_FAIL = 'GET_WASTEWATER_TREATMENT_PER_GROUP_FAIL';
// ---Waste-to-Biochar-Production---
export const GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_GROUP_SUCCESS = 'GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_GROUP_SUCCESS';
export const GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_GROUP_FAIL = 'GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_GROUP_FAIL';

// WASTE GENERATED PER FACILITY

// --- Waste to Landfill ---
export const GET_WASTE_TO_LANDFILL_PER_FACILITY_SUCCESS = 'GET_WASTE_TO_LANDFILL_PER_FACILITY_SUCCESS';
export const GET_WASTE_TO_LANDFILL_PER_FACILITY_FAIL = 'GET_WASTE_TO_LANDFILL_PER_FACILITY_FAIL';
// --- Waste to Recycling ---
export const GET_WASTE_TO_RECYCLING_PER_FACILITY_SUCCESS = 'GET_WASTE_TO_RECYCLING_PER_FACILITY_SUCCESS';
export const GET_WASTE_TO_RECYCLING_PER_FACILITY_FAIL = 'GET_WASTE_TO_RECYCLING_PER_FACILITY_FAIL';
// --- Waste to Composting ---
export const GET_WASTE_TO_COMPOSTING_PER_FACILITY_SUCCESS = 'GET_WASTE_TO_COMPOSTING_PER_FACILITY_SUCCESS';
export const GET_WASTE_TO_COMPOSTING_PER_FACILITY_FAIL = 'GET_WASTE_TO_COMPOSTING_PER_FACILITY_FAIL';
// --- Wastewater Treatment ---
export const GET_WASTEWATER_TREATMENT_PER_FACILITY_SUCCESS = 'GET_WASTEWATER_TREATMENT_PER_FACILITY_SUCCESS';
export const GET_WASTEWATER_TREATMENT_PER_FACILITY_FAIL = 'GET_WASTEWATER_TREATMENT_PER_FACILITY_FAIL';
// --- Waste to Biochar Production ---
export const GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_FACILITY_SUCCESS = 'GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_FACILITY_SUCCESS';
export const GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_FACILITY_FAIL = 'GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_FACILITY_FAIL';

// FLIGHTS AND ACCOMMODATION PER GROUP
export const GET_FLIGHTS_AND_ACCOMMODATION_PER_GROUP_SUCCESS = 'GET_FLIGHTS_AND_ACCOMMODATION_PER_GROUP_SUCCESS';
export const GET_FLIGHTS_AND_ACCOMMODATION_PER_GROUP_FAIL = 'GET_FLIGHTS_AND_ACCOMMODATION_PER_GROUP_FAIL';

// FLIGHTS AND ACCOMMODATION PER FACILITY
export const GET_FLIGHTS_AND_ACCOMMODATION_PER_FACILITY_SUCCESS = 'GET_FLIGHTS_AND_ACCOMMODATION_PER_FACILITY_SUCCESS';
export const GET_FLIGHTS_AND_ACCOMMODATION_PER_FACILITY_FAIL = 'GET_FLIGHTS_AND_ACCOMMODATION_PER_FACILITY_FAIL';

// CAR HIRE PER GROUP
// diesel
export const GET_CAR_HIRE_DIESEL_PER_GROUP_SUCCESS = 'GET_CAR_HIRE_DIESEL_PER_GROUP_SUCCESS';
export const GET_CAR_HIRE_DIESEL_PER_GROUP_FAIL = 'GET_CAR_HIRE_DIESEL_PER_GROUP_FAIL';
// petrol
export const GET_CAR_HIRE_PETROL_PER_GROUP_SUCCESS = 'GET_CAR_HIRE_PETROL_PER_GROUP_SUCCESS';
export const GET_CAR_HIRE_PETROL_PER_GROUP_FAIL = 'GET_CAR_HIRE_PETROL_PER_GROUP_FAIL';

// CAR HIRE PER FACILITY
// diesel
export const GET_CAR_HIRE_DIESEL_PER_FACILITY_SUCCESS = 'GET_CAR_HIRE_DIESEL_PER_FACILITY_SUCCESS';
export const GET_CAR_HIRE_DIESEL_PER_FACILITY_FAIL = 'GET_CAR_HIRE_DIESEL_PER_FACILITY_FAIL';
// petrol
export const GET_CAR_HIRE_PETROL_PER_FACILITY_SUCCESS = 'GET_CAR_HIRE_PETROL_PER_FACILITY_SUCCESS';
export const GET_CAR_HIRE_PETROL_PER_FACILITY_FAIL = 'GET_CAR_HIRE_PETROL_PER_FACILITY_FAIL';

// PETROL CARDS PER GROUP
// diesel
export const GET_PETROL_CARDS_DIESEL_PER_GROUP_SUCCESS = 'GET_PETROL_CARDS_DIESEL_PER_GROUP_SUCCESS';
export const GET_PETROL_CARDS_DIESEL_PER_GROUP_FAIL = 'GET_PETROL_CARDS_DIESEL_PER_GROUP_FAIL';
// petrol
export const GET_PETROL_CARDS_PETROL_PER_GROUP_SUCCESS = 'GET_PETROL_CARDS_PETROL_PER_GROUP_SUCCESS';
export const GET_PETROL_CARDS_PETROL_PER_GROUP_FAIL = 'GET_PETROL_CARDS_PETROL_PER_GROUP_FAIL';

// PETROL CARDS PER FACILITY
export const GET_PETROL_CARDS_DIESEL_PER_FACILITY_SUCCESS = 'GET_PETROL_CARDS_DIESEL_PER_FACILITY_SUCCESS';
export const GET_PETROL_CARDS_DIESEL_PER_FACILITY_FAIL = 'GET_PETROL_CARDS_DIESEL_PER_FACILITY_FAIL';
export const GET_PETROL_CARDS_PETROL_PER_FACILITY_SUCCESS = 'GET_PETROL_CARDS_PETROL_PER_FACILITY_SUCCESS';
export const GET_PETROL_CARDS_PETROL_PER_FACILITY_FAIL = 'GET_PETROL_CARDS_PETROL_PER_FACILITY_FAIL';

// DOWNSTREAM DISTRIBUTION PER GROUP
export const GET_INTER_DC_DISTRIBUTION_PER_GROUP_SUCCESS = 'GET_INTER_DC_DISTRIBUTION_PER_GROUP_SUCCESS';
export const GET_INTER_DC_DISTRIBUTION_PER_GROUP_FAIL = 'GET_INTER_DC_DISTRIBUTION_PER_GROUP_FAIL';
export const GET_FARM_DC_DISTRIBUTION_PER_GROUP_SUCCESS = 'GET_FARM_DC_DISTRIBUTION_PER_GROUP_SUCCESS';
export const GET_FARM_DC_DISTRIBUTION_PER_GROUP_FAIL = 'GET_FARM_DC_DISTRIBUTION_PER_GROUP_FAIL';
export const GET_SHIPPING_DISTRIBUTION_PER_GROUP_SUCCESS = 'GET_SHIPPING_DISTRIBUTION_PER_GROUP_SUCCESS';
export const GET_SHIPPING_DISTRIBUTION_PER_GROUP_FAIL = 'GET_SHIPPING_DISTRIBUTION_PER_GROUP_FAIL';
export const GET_REGIONAL_DISTRIBUTION_PER_GROUP_SUCCESS = 'GET_REGIONAL_DISTRIBUTION_PER_GROUP_SUCCESS';
export const GET_REGIONAL_DISTRIBUTION_PER_GROUP_FAIL = 'GET_REGIONAL_DISTRIBUTION_PER_GROUP_FAIL';

// DOWNSTREAM DISTRIBUTION PER FACILITY
export const GET_INTER_DC_DISTRIBUTION_PER_FACILITY_SUCCESS = 'GET_INTER_DC_DISTRIBUTION_PER_FACILITY_SUCCESS';
export const GET_INTER_DC_DISTRIBUTION_PER_FACILITY_FAIL = 'GET_INTER_DC_DISTRIBUTION_PER_FACILITY_FAIL';
export const GET_FARM_DC_DISTRIBUTION_PER_FACILITY_SUCCESS = 'GET_FARM_DC_DISTRIBUTION_PER_FACILITY_SUCCESS';
export const GET_FARM_DC_DISTRIBUTION_PER_FACILITY_FAIL = 'GET_FARM_DC_DISTRIBUTION_PER_FACILITY_FAIL';
export const GET_SHIPPING_DISTRIBUTION_PER_FACILITY_SUCCESS = 'GET_SHIPPING_DISTRIBUTION_PER_FACILITY_SUCCESS';
export const GET_SHIPPING_DISTRIBUTION_PER_FACILITY_FAIL = 'GET_SHIPPING_DISTRIBUTION_PER_FACILITY_FAIL';
export const GET_REGIONAL_DISTRIBUTION_PER_FACILITY_SUCCESS = 'GET_REGIONAL_DISTRIBUTION_PER_FACILITY_SUCCESS';
export const GET_REGIONAL_DISTRIBUTION_PER_FACILITY_FAIL = 'GET_REGIONAL_DISTRIBUTION_PER_FACILITY_FAIL';

// WATER PER GROUP
export const GET_WATER_PER_GROUP_SUCCESS = 'GET_WATER_PER_GROUP_SUCCESS';
export const GET_WATER_PER_GROUP_FAIL = 'GET_WATER_PER_GROUP_FAIL';
// WATER PER FACILITY
export const GET_WATER_PER_FACILITY_SUCCESS = 'GET_WATER_PER_FACILITY_SUCCESS';
export const GET_WATER_PER_FACILITY_FAIL = 'GET_WATER_PER_FACILITY_FAIL';
// CHEMICALS AND ADDITIVES PER GROUP
export const GET_CHEMICALS_AND_ADDITIVES_PER_GROUP_SUCCESS = 'GET_CHEMICALS_AND_ADDITIVES_PER_GROUP_SUCCESS';
export const GET_CHEMICALS_AND_ADDITIVES_PER_GROUP_FAIL = 'GET_CHEMICALS_AND_ADDITIVES_PER_GROUP_FAIL';
// CHEMICALS AND ADDITIVES PER FACILITY
export const GET_CHEMICALS_AND_ADDITIVES_PER_FACILITY_SUCCESS = 'GET_CHEMICALS_AND_ADDITIVES_PER_FACILITY_SUCCESS';
export const GET_CHEMICALS_AND_ADDITIVES_PER_FACILITY_FAIL = 'GET_CHEMICALS_AND_ADDITIVES_PER_FACILITY_FAIL';
// WOODEN PRODUCTS PER GROUP
export const GET_WOODEN_PRODUCTS_PER_GROUP_SUCCESS = 'GET_WOODEN_PRODUCTS_PER_GROUP_SUCCESS';
export const GET_WOODEN_PRODUCTS_PER_GROUP_FAIL = 'GET_WOODEN_PRODUCTS_PER_GROUP_FAIL';
// WOODEN PRODUCTS PER FACILITY
export const GET_WOODEN_PRODUCTS_PER_FACILITY_SUCCESS = 'GET_WOODEN_PRODUCTS_PER_FACILITY_SUCCESS';
export const GET_WOODEN_PRODUCTS_PER_FACILITY_FAIL = 'GET_WOODEN_PRODUCTS_PER_FACILITY_FAIL';
// PACKAGING PER GROUP
export const GET_PACKAGING_PER_GROUP_SUCCESS = 'GET_PACKAGING_PER_GROUP_SUCCESS';
export const GET_PACKAGING_PER_GROUP_FAIL = 'GET_PACKAGING_PER_GROUP_FAIL';
// PACKAGING PER FACILITY
export const GET_PACKAGING_PER_FACILITY_SUCCESS = 'GET_PACKAGING_PER_FACILITY_SUCCESS';
export const GET_PACKAGING_PER_FACILITY_FAIL = 'GET_PACKAGING_PER_FACILITY_FAIL';
// WINE AND GRAPES PER GROUP
export const GET_WINE_AND_GRAPES_PER_GROUP_SUCCESS = 'GET_WINE_AND_GRAPES_PER_GROUP_SUCCESS';
export const GET_WINE_AND_GRAPES_PER_GROUP_FAIL = 'GET_WINE_AND_GRAPES_PER_GROUP_FAIL';
// WINE AND GRAPES PER FACILITY
export const GET_WINE_AND_GRAPES_PER_FACILITY_SUCCESS = 'GET_WINE_AND_GRAPES_PER_FACILITY_SUCCESS';
export const GET_WINE_AND_GRAPES_PER_FACILITY_FAIL = 'GET_WINE_AND_GRAPES_PER_FACILITY_FAIL';
// OTHER PER GROUP
export const GET_OTHER_PER_GROUP_SUCCESS = 'GET_OTHER_PER_GROUP_SUCCESS';
export const GET_OTHER_PER_GROUP_FAIL = 'GET_OTHER_PER_GROUP_FAIL';
// OTHER PER FACILITY
export const GET_OTHER_PER_FACILITY_SUCCESS = 'GET_OTHER_PER_FACILITY_SUCCESS';
export const GET_OTHER_PER_FACILITY_FAIL = 'GET_OTHER_PER_FACILITY_FAIL';
// FERTILIZER PER GROUP
export const GET_FERTILIZERS_PER_GROUP_SUCCESS = 'GET_FERTILIZERS_PER_GROUP_SUCCESS'
export const GET_FERTILIZERS_PER_GROUP_FAIL = 'GET_FERTILIZERS_PER_GROUP_FAIL'
// FERTILIZERS PER FACILITY
export const GET_FERTILIZERS_PER_FACILITY_SUCCESS = 'GET_FERTILIZERS_PER_FACILITY_SUCCESS'
export const GET_FERTILIZERS_PER_FACILITY_FAIL = 'GET_FERTILIZERS_PER_FACILITY_FAIL'
// AGROCHEMICALS PER GROUP
export const GET_AGROCHEMICALS_PER_GROUP_SUCCESS = 'GET_AGROCHEMICALS_PER_GROUP_SUCCESS'
export const GET_AGROCHEMICALS_PER_GROUP_FAIL = 'GET_AGROCHEMICALS_PER_GROUP_FAIL'
// AGROCHEMICALS PER FACILITY
export const GET_AGROCHEMICALS_PER_FACILITY_SUCCESS = 'GET_AGROCHEMICALS_PER_FACILITY_SUCCESS'
export const GET_AGROCHEMICALS_PER_FACILITY_FAIL = 'GET_AGROCHEMICALS_PER_FACILITY_FAIL'
// CAPITAL GOODS AND SERVICES PER GROUP
export const GET_CAPITAL_GOODS_AND_SERVICES_PER_GROUP_SUCCESS = 'GET_CAPITAL_GOODS_AND_SERVICES_PER_GROUP_SUCCESS'
export const GET_CAPITAL_GOODS_AND_SERVICES_PER_GROUP_FAIL = 'GET_CAPITAL_GOODS_AND_SERVICES_PER_GROUP_FAIL'
// CAPITAL GOODS AND SERVICES PER FACILITY
export const GET_CAPITAL_GOODS_AND_SERVICES_PER_FACILITY_SUCCESS = 'GET_CAPITAL_GOODS_AND_SERVICES_PER_FACILITY_SUCCESS'
export const GET_CAPITAL_GOODS_AND_SERVICES_PER_FACILITY_FAIL = 'GET_CAPITAL_GOODS_AND_SERVICES_PER_FACILITY_FAIL'

export const EXPORT_COMPANY_CONSUMPTION_SUCCESS = 'EXPORT_COMPANY_CONSUMPTION_SUCCESS'
export const EXPORT_COMPANY_CONSUMPTION_FAIL = 'EXPORT_COMPANY_CONSUMPTION_FAIL'

export const EXPORT_GROUP_CONSUMPTION_SUCCESS = 'EXPORT_GROUP_CONSUMPTION_SUCCESS'
export const EXPORT_GROUP_CONSUMPTION_FAIL = 'EXPORT_GROUP_CONSUMPTION_FAIL'
